// IntroPage.jsx
// React equivalent of escape_peace-old/rules.php — story introduction screen.
import React from 'react';
import { Link } from 'react-router-dom';
import EscapeHeader from '../../../components/escape-to-inner-peace/layout/EscapeHeader';
import '../../../games/escape-to-inner-peace/styles/theme.css';
import './intro.css';

const STORY_TEXT =
  "You find yourself trapped in a mysterious, dimly lit room – your own Mind Palace. " +
  "The only way out is by solving self-care and self-love puzzles that help you unlock the doors of stress, " +
  "overthinking, and burnout. Each puzzle reveals a 'Key to Well-being' that brings you closer to ultimate self-care freedom.";

function IntroPage() {
  return (
    <div className="escape-intro-page">
      <EscapeHeader backTo="/escape-to-inner-peace" />

      <div className="escape-intro-content">
        <ul className="escape-intro-textli">
          <li>{STORY_TEXT}</li>
        </ul>
      </div>
      {/* .escape-intro-content is positioned/sized per breakpoint in intro.css */}

      <div className="escape-intro-action">
        <Link to="/escape-to-inner-peace/rules" className="escape-begin-btn">
          NEXT
        </Link>
      </div>
    </div>
  );
}

export default IntroPage;
